import * as urlUtils from 'utils/Url';


// Emails
export function getPathEmails(qs={}) {
  return urlUtils.appendQueryString(`/emails`, qs);
}

export function getPathBroadcastEmails(qs={}) {
  return urlUtils.appendQueryString(`/broadcast-emails`, qs);
}

export function getPathWorkflowEmails(qs={}) {
  return urlUtils.appendQueryString(`/workflow-emails`, qs);
}

export function getPathAddEmail(qs={}) {
  return urlUtils.appendQueryString(`/emails/add`, qs);
}

export function getPathEditEmail(emailId, qs={}) {
  return urlUtils.appendQueryString(`/emails/${emailId}/edit`, qs);
}

export function getPathReplicateEmail(emailId, qs={}) {
  return urlUtils.appendQueryString(`/emails/${emailId}/replicate`, qs);
}

export function getPathEmailDeliveryStats(qs={}) {
  return urlUtils.appendQueryString(`/email-delivery-stats`, qs);
}


// Templates
export function getPathLibraryEmailTemplates(qs={}) {
  return urlUtils.appendQueryString(`/library-email-templates`, qs);
}

export function getPathCustomEmailTemplates(qs={}) {
  return urlUtils.appendQueryString(`/custom-email-templates`, qs);
}

export function getPathAddEmailTemplate(qs={}) {
  return urlUtils.appendQueryString(`/email-templates/add`, qs);
}

export function getPathEditEmailTemplate(templateId, qs={}) {
  return urlUtils.appendQueryString(`/email-templates/${templateId}/edit`, qs);
}

export function getPathReplicateEmailTemplate(templateId, qs={}) {
  return urlUtils.appendQueryString(`/email-templates/${templateId}/replicate`, qs);
}


// Broadcasts
export function getPathBroadcasts(qs={}) {
  return urlUtils.appendQueryString(`/broadcasts`, qs);
}


// Tags
export function getPathEmailTags(qs={}) {
  return urlUtils.appendQueryString(`/email-tags`, qs);
}


// Domains
export function getPathEmailDomains(qs={}) {
  return urlUtils.appendQueryString(`/email-domains`, qs);
}

export function getPathEmailDomainDnsRecords(domainId) {
  return `/email-domain-dns-records/${domainId}`;
}


// Profiles
export function getPathEmailProfiles(qs={}) {
  return urlUtils.appendQueryString(`/email-profiles`, qs);
}

export function getPathAddEmailProfile() {
  return `/email-profiles/add`;
}

export function getPathEmailProfileCompleteVerify() {
  return `/email-profiles/complete/verify`;
}

export function getPathEditEmailProfile(profileId) {
  return `/email-profiles/${profileId}/edit`;
}


// Recipients
export function getPathEmailRecipients(emailId, qs={}) {
  return urlUtils.appendQueryString(`/emails/${emailId}/recipients`, qs);
}

export function getPathEmailAnalytics(emailId, qs={}) {
  return urlUtils.appendQueryString(`/emails/${emailId}/analytics`, qs);
}

export function getPathEmailConversions(emailId, qs={}) {
  return urlUtils.appendQueryString(`/emails/${emailId}/conversions`, qs);
}

// Settings
export function getPathEmailSettings() {
  return `/email-settings`;
}

export function getPathEditEmailSettings() {
  return `/email-settings/edit`;
}

export function getPathEditEmailPreferences() {
  return `/email-preferences/edit`;
}

export function getPathEmailSendingRules() {
  return `/email-sending-rules`;
}

export function getPathEditEmailSendingRules() {
  return `/email-sending-rules/edit`;
}

// SMTP
export function getPathSmtpProfiles(qs={}) {
  return urlUtils.appendQueryString(`/smtp-profiles`, qs);
}

export function getPathAddSmtpProfile(qs={}) {
  return urlUtils.appendQueryString(`/smtp-profiles/add`, qs);
}

export function getPathPreviewSmtpProfile(profileId, qs={}) {
  return urlUtils.appendQueryString(`/smtp-profiles/${profileId}/preview`, qs);
}

export function getPathSmtpProfileDnsRecords(profileId) {
  return `/smtp-profile-dns-records/${profileId}`;
}
